import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';

const N: React.FC = () => {
    const { t } = useLang('stream_ultra_x');
    const { locale = '' } = useRouter();
    const boxRef = useRef<HTMLDivElement>(null);
    const videosMap: { [key: string]: string } = {
        en: 'https://websiteoss.ecoflow.com/upload/video/1754015172421/14_en.mp4',
        de: 'https://websiteoss.ecoflow.com/upload/video/1753865402440/14_de.mp4',
    };

    const posterMap: { [key: string]: string } = {
        en: 'https://websiteoss.ecoflow.com/upload/image/1754399500954/14_en_pc.jpg',
        de: 'https://websiteoss.ecoflow.com/upload/image/1754399504677/14_de_pc.jpg',
    };

    const [load, setLoad] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneN = AniContainer.create({
                triggerElement: '.stream-ultra-x-I',
                triggerHook: 1,
                onEnter: () => setLoad(true),
            });
            return () => {
                sceneN.destroy();
            };
        }
    }, []);

    useEffect(() => {
        if (!load || !boxRef.current) return;
        const playingVideo = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const video: HTMLVideoElement | null = document.querySelector('#stream-ultra-x-N video');
                    if (video && entry.isIntersecting) {
                        video.currentTime = 0;
                        video.play();
                    }
                });
            },
            {
                threshold: 0.5,
            },
        );
        playingVideo.observe(boxRef.current);
        return () => {
            playingVideo.disconnect();
        };
    }, [load]);

    return (
        <section
            className={`${css.section} stream-ultra-x-N GtmModuleData-section`}
            id="stream-ultra-x-N"
            ref={boxRef}
            data-section-id={'stream-ultra-x-N'}
            data-section-title={t('N_title')}
        >
            <div className="info">
                <p className="title">{t('N_title')}</p>
                <p className="desc">{t('N_desc')}</p>
                <ul className="items">
                    {[1, 2].map((i: number) => (
                        <li className="item" key={i}>
                            <p className="item-title">{t(`N_item${i}_title`)}</p>
                            <p className="item-desc">{t(`N_item${i}_desc`)}</p>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="video">
                {load && (
                    <video
                        src={videosMap[locale] || videosMap.en}
                        poster={posterMap[locale] || posterMap.en}
                        loop
                        // autoPlay
                        preload="auto"
                        width="100%"
                        height="100%"
                        playsInline
                        muted
                        aria-label={t('N_title')}
                    />
                )}
            </div>
            <p className="tip">{t('N_tip')}</p>
        </section>
    );
};

export default N;
